<template>
  <div>
    <v-data-table-server
      v-model:items-per-page="options.pageSize"
      :headers="headers"
      :items="rows"
      :loading="loading"
      :items-length="totalItems"
      :search="options.search"
      class="elevation-1"
      @update:options="loadItems"
    >
      <template #top>
        <v-text-field
          v-model="options.search"
          label="Leita"
          class="mx-4"
          @input="onSearch"
        />
      </template>

      <template #item.date="{ item }">
        <span>{{ fmtDateTime(item.date) }}</span>
      </template>
    </v-data-table-server>

    <v-snackbar
      v-model="snackbar.open"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      location="top right"
    >
      {{ snackbar.text }}
      <template #actions>
        <v-btn variant="text" @click="snackbar.open = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useAdminStore } from '@/stores/useAdminStore'

type LogItem = {
  date: string | Date
  exceptionType?: string
  title?: string
  message?: string
  user?: string
}

const admin = useAdminStore()
const { logs, loading } = storeToRefs(admin)
const { getLogs } = admin

const options = ref({ search: '', page: 1, pageSize: 50 })

const headers = [
  { title: 'Dagsetning', value: 'date' },
  { title: 'Týpa', value: 'exceptionType' },
  { title: 'Titill', value: 'title' },
  { title: 'Skilaboð', value: 'message' },
  { title: 'Notandi', value: 'user' },
]

// If your API returns `{ logs: [], pagination: { totalRecords } }`, map to an array
const rows = computed<LogItem[]>(() => {
  const raw = logs.value as any
  if (Array.isArray(raw)) return raw as LogItem[]
  if (raw?.logs && Array.isArray(raw.logs)) return raw.logs as LogItem[]
  return []
})

const totalItems = computed(() => {
  const raw = logs.value as any
  console.log('Raw logs data:', raw)
  console.log('Pagination object:', raw?.pagination)
  console.log('Total records:', raw?.pagination?.totalRecords)
  
  if (raw?.pagination?.totalRecords) return raw.pagination.totalRecords
  if (raw?.totalRecords) return raw.totalRecords
  if (raw?.total) return raw.total
  return rows.value.length
})

function loadItems({ page, itemsPerPage, sortBy }: { page: number; itemsPerPage: number; sortBy: any[] }) {
  options.value.page = page
  options.value.pageSize = itemsPerPage
  fetchLogs()
}

onMounted(fetchLogs)
let searchTimer: number | undefined
function onSearch() {
  clearTimeout(searchTimer)
  searchTimer = window.setTimeout(() => {
    options.value.page = 1
    fetchLogs()
  }, 500)
}

function fmtDateTime(v: string | Date): string {
  const d = v instanceof Date ? v : new Date(v)
  const yyyy = d.getFullYear()
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  const hh = String(d.getHours()).padStart(2, '0')
  const mi = String(d.getMinutes()).padStart(2, '0')
  return `${dd}-${mm}-${yyyy} ${hh}:${mi}`
}

async function fetchLogs() {
  await getLogs({
    page: options.value.page,
    pageSize: options.value.pageSize,
    search: options.value.search,
  })
}

// basic snackbar scaffold (kept for parity)
const snackbar = ref({ open: false, text: 'Vistað', timeout: 3000, color: 'success' as 'success'|'error' })
</script>

<style scoped lang="scss">
.v-card { height: 700px !important; }
</style>
